import moment from 'moment';

export default {
  methods: {
    async changeSalario() {
      try {
        if (
          this.salarioBase !==
          this.dataForm[this.namePath].info_afiliacion.salario
        ) {
          this.salarioBase =
            this.dataForm[this.namePath].info_afiliacion.salario;
          if (
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 1
          ) {
            await this.changeIngreso();
          }
          if (
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 2
          ) {
            await this.updateDataForm({
              state: 'info_afiliacion/dias',
              data: 30,
            });
          }
          if (
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 3
          ) {
            await this.changeRetiro();
          }
        }
        return true;
      } catch (e) {
        console.log(e);
      }
    },
    async changeNovedad() {
      if (this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 1) {
        await this.changeIngreso();
      }
      if (this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 2) {
        await this.updateDataForm({ state: 'info_afiliacion/dias', data: 30 });
      }
      if (this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 3) {
        await this.changeRetiro();
      }
    },
    openRegistro() {
      window.open(this.linkaporte, 'blank');
    },
    async searchsData(tipo) {
      this.statusDescargar = false;
      this.resetDataGet();
      const await00 = this.onInit();
      if (tipo === 'afiliado') {
        const await03 = this.updateDataForm({
          state: 'servicios_nuevos',
          data: [],
        });
        const await01 = this.updateDataForm({
          state: 'servicios_activos',
          data: [],
        });
        const await02 = this.updateCrud({
          state: 'dataMultiple/' + this.namePath + '/multiple_servicios',
          data: this.predeterminados[this.namePath].multiple_servicios,
        });
        await Promise.all([await00, await01, await02, await03]);

        let data = await this.getData({
          route: 'get_afiliadoaporte',
          data: this.searchSw.value,
        });
        if (data.length != 0) {
          this.salarioBase = data.info_afiliacion.salario;

          for (let i = 0; i < data.servicios_activos.length; i++) {
            let indexMultiple = _.findIndex(
              this.dataMultiple[this.namePath].multiple_servicios,
              ['name', data.servicios_activos[i].name]
            );
            this.$set(
              this.dataMultiple[this.namePath].multiple_servicios,
              indexMultiple,
              this.deepCopy(data.servicios_activos[i])
            );
          }

          if (data.mes !== undefined && data.ano !== undefined) {
            data.info_afiliacion.dias = 30;
            data.info_afiliacion.id_list_novedad = 2;
            this.mesPeriodo = this.gettersDatalist('list_mes', data.mes)[0];
            this.anoPeriodo = this.gettersDatalist('list_ano', data.ano)[0];
          } else {
            this.mesPeriodo = this.gettersDatalist(
              'list_mes',
              data.info_afiliacion.mes_periodo
            )[0];
            this.anoPeriodo = this.gettersDatalist(
              'list_ano',
              data.info_afiliacion.ano_periodo
            )[0];
          }
          this.info_incapacidades = data.info_incapacidades;

          const await1 = this.updateDataForm({
            state: 'datos_afiliado',
            data: data.datos_afiliado,
          });
          const await2 = this.updateDataForm({
            state: 'info_afiliacion',
            data: data.info_afiliacion,
          });
          const await3 = this.updateDataForm({
            state: 'servicios_activos',
            data: data.servicios_activos,
          });
          const await4 = this.updateDataForm({
            state: 'servicios_nuevos',
            data: data.servicios_nuevos,
          });
          const await5 = this.updateDataForm({
            state: 'descuentos_referido',
            data: data.descuentos_referido,
          });
          const await6 = this.updateDataForm({
            state: 'notas_pendientes',
            data: data.notas_pendientes,
          });
          await Promise.all([await1, await2, await3, await4, await5, await6]);
          this.novedad =
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad;
          this.ingreso = this.dataForm[this.namePath].info_afiliacion.ingreso;
          this.indexccf = _.findIndex(
            this.dataForm[this.namePath].servicios_activos,
            ['name', 'Ccf']
          );
          if (this.indexccf != -1) {
            this.ingresoccf =
              this.dataForm[this.namePath].servicios_activos[
                this.indexccf
              ].iniciolabores;
            this.salarioccf =
              this.dataForm[this.namePath].info_afiliacion.salario;
          }
          if (
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 1
          ) {
            await this.changeIngreso();
          }

          if (
            this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 3
          ) {
            await this.changeRetiro();
          }
          let historial = _.concat(
            data.afiliacion_registro,
            data.aportes_registro
          );
          historial = _.orderBy(historial, ['fecha'], ['desc']);
          this.historial = historial;
        } else {
          this.statusDescargar = true;
        }
      }
      if (tipo === 'centro') {
        this.nameSearchs = 'AportesCentros';
        await this.getDataGet({
          route: 'get_centroaporte',
          data: {
            id_datos_contacto: this.searchSw.value,
            mes_periodo: this.mesPeriodo.id,
            ano_periodo: this.anoPeriodo.id,
          },
        });
        this.updateDataForm({ state: 'servicios_activos', data: [] });
      }
      if (tipo === 'razon') {
        this.nameSearchs = 'AportesRazon';
        await this.getDataGet({
          route: 'get_razonaporte',
          data: {
            id_datos_razon: this.searchSw.value,
            mes_periodo: this.mesPeriodo.id,
            ano_periodo: this.anoPeriodo.id,
          },
        });
        this.updateDataForm({ state: 'servicios_activos', data: [] });
      }
      if (tipo === 'asesor') {
        this.nameSearchs = 'AportesAsesor';
        await this.getDataGet({
          route: 'get_asesoraporte',
          data: {
            id_datos_asesor: this.searchSw.value,
            mes_periodo: this.mesPeriodo.id,
            ano_periodo: this.anoPeriodo.id,
          },
        });
        this.updateDataForm({ state: 'servicios_activos', data: [] });
      }
    },
    limpiarSearchs() {
      this.statusDescargar = false;
      this.searchSw.value = '';
      this.resetDataGet();
      this.mesPeriodo = {
        id: this.fecha().fecha.mesHoy,
        name: this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0]
          .name,
      };
      this.anoPeriodo = {
        id: this.fecha().fecha.anoHoy,
        name: this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0]
          .name,
      };
    },

    async changeIngreso() {
      if (this.ingreso !== null) {
        if (
          this.dataForm[this.namePath].info_afiliacion.ingreso === '' ||
          this.dataForm[this.namePath].info_afiliacion.ingreso === null
        ) {
          this.dataForm[this.namePath].info_afiliacion.ingreso = this.ingreso;
        }
        let dias = moment(
          this.dataForm[this.namePath].info_afiliacion.ingreso
        ).format('DD');
        if (dias > 30) {
          dias = 30;
        }
        dias = 31 - dias;
        let salario = (this.salarioBase / 30) * dias;
        this.salarioproporcional = salario;
        await this.updateDataForm({
          state: 'info_afiliacion/dias',
          data: dias,
        });
      }

      return true;
    },
    sumarConfirmar() {
      switch (this.dataForm[this.namePath].info_afiliacion.id_list_novedad) {
        case 1:
          return _.sumBy(
            this.dataMultiple[this.namePath].multiple_servicios,
            'valoringreso'
          );
          break;
        case 2:
        case 4:
          return _.sumBy(
            this.dataMultiple[this.namePath].multiple_servicios,
            'valor'
          );
          break;
        case 3:
          return _.sumBy(
            this.dataMultiple[this.namePath].multiple_servicios,
            'valorretiro'
          );
          break;
      }
    },
    async changeRetiro() {
      let dias;
      let salario;
      if (
        this.dataForm[this.namePath].info_afiliacion.retiro === '' ||
        this.dataForm[this.namePath].info_afiliacion.retiro === null
      ) {
        if (this.novedad === 1) {
          this.dataForm[this.namePath].info_afiliacion.retiro =
            this.dataForm[this.namePath].info_afiliacion.ingreso;
          dias = 1;
          salario = (this.salarioBase / 30) * dias;
        } else {
          this.dataForm[this.namePath].info_afiliacion.retiro = this.fecha(
            this.anoPeriodo.id + '-' + this.mesPeriodo.id + '-01'
          ).fecha.retPrimero;
          dias = 1;
          salario = (this.salarioBase / 30) * dias;
        }
      } else {
        let fecha11 = moment(
          this.dataForm[this.namePath].info_afiliacion.ingreso
        );
        let fecha21 = moment(
          this.dataForm[this.namePath].info_afiliacion.retiro
        );
        let mes_ingreso = parseInt(
          moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format(
            'MM'
          )
        );
        let mes_retiro = parseInt(
          moment(this.dataForm[this.namePath].info_afiliacion.retiro).format(
            'MM'
          )
        );
        let dias1 = parseInt(fecha21.diff(fecha11, 'months'));

        if (dias1 === 0 && mes_retiro === mes_ingreso) {
          this.novedad = 1;
          let mesretiro =
            parseInt(
              moment(
                this.dataForm[this.namePath].info_afiliacion.retiro
              ).format('MM')
            ) + 1;
          let anoretiro = parseInt(
            moment(this.dataForm[this.namePath].info_afiliacion.retiro).format(
              'YYYY'
            )
          );
          let diaretiro = parseInt(
            moment(this.dataForm[this.namePath].info_afiliacion.retiro).format(
              'DD'
            )
          );
          if (diaretiro === 31) {
            this.dataForm[this.namePath].info_afiliacion.retiro = this.fecha(
              anoretiro + '-' + mesretiro + '-30'
            ).fecha.retUltimo;
          }
          let fecha1 = moment(
            this.dataForm[this.namePath].info_afiliacion.ingreso
          );
          let fecha2 = moment(
            this.dataForm[this.namePath].info_afiliacion.retiro
          );
          dias = parseInt(fecha2.diff(fecha1, 'days')) + 1;
          if (dias <= 0) {
            this.dataForm[this.namePath].info_afiliacion.retiro =
              this.dataForm[this.namePath].info_afiliacion.ingreso;
            dias = 1;
          }
          salario = (this.salarioBase / 30) * dias;
        } else {
          let mesretiro =
            parseInt(
              moment(
                this.dataForm[this.namePath].info_afiliacion.retiro
              ).format('MM')
            ) + 1;
          let anoretiro = parseInt(
            moment(this.dataForm[this.namePath].info_afiliacion.retiro).format(
              'YYYY'
            )
          );
          let diaretiro = parseInt(
            moment(this.dataForm[this.namePath].info_afiliacion.retiro).format(
              'DD'
            )
          );

          if (mesretiro === 13) {
            mesretiro = 1;
            anoretiro = anoretiro + 1;
          }
          if (
            this.anoPeriodo.id !== anoretiro ||
            this.mesPeriodo.id != mesretiro
          ) {
            this.dataForm[this.namePath].info_afiliacion.retiro = this.fecha(
              this.anoPeriodo.id + '-' + this.mesPeriodo.id + '-01'
            ).fecha.retPrimero;
            dias = 1;
          } else {
            dias = moment(
              this.dataForm[this.namePath].info_afiliacion.retiro
            ).format('DD');
          }
          salario = (this.salarioBase / 30) * dias;
        }
      }
      this.salarioproporcional = salario;
      await this.updateDataForm({ state: 'info_afiliacion/dias', data: dias });

      return true;
    },
    invalidNovedad() {
      return _.find(this.errorsAportes(), 'value') ? true : false;
    },
    errorsAportes() {
      try {
        let errorsAportes = [];
        if (
          this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 1
        ) {
          let fecha1 = moment(
            this.dataForm[this.namePath].info_afiliacion.ingreso
          );
          var fecha2;
          if (this.mesPeriodo.id == 2) {
            fecha2 = moment(
              this.anoPeriodo.id + '-' + this.mesPeriodo.id + '-28'
            );
          } else {
            fecha2 = moment(
              this.anoPeriodo.id + '-' + this.mesPeriodo.id + '-30'
            );
          }
          let diff = parseInt(fecha2.diff(fecha1, 'months'));
          if (diff !== 1) {
            errorsAportes.push({
              name: 'El inicio de labores no concuerda con el periodo de aporte',
              value: true,
            });
          }
        }
        if (
          this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 3
        ) {
          let fecha1 = moment(
            this.dataForm[this.namePath].info_afiliacion.retiro
          );
          var fecha2;
          if (this.mesPeriodo.id == 2) {
            fecha2 = moment(
              this.anoPeriodo.id + '-' + this.mesPeriodo.id + '-28'
            );
          } else {
            fecha2 = moment(
              this.anoPeriodo.id + '-' + this.mesPeriodo.id + '-30'
            );
          }
          let diff = parseInt(fecha2.diff(fecha1, 'months'));
          if (diff !== 1) {
            errorsAportes.push({
              name: 'La fecha de retiro no concuerda con el periodo de aporte',
              value: true,
            });
          }
        }
        if (
          this.dataForm[this.namePath].info_afiliacion.id_list_novedad === 4
        ) {
          let indexAfp = _.findIndex(
            this.dataMultiple[this.namePath].multiple_servicios,
            { name: 'Afp', check: 1 }
          );
          if (indexAfp === -1) {
            errorsAportes.push({
              name: 'Para generar un retiro solo AFP debe seleccionar y asignar una AFP',
              value: true,
            });
          }
        }

        let ninguno = 'Debe asignar la entidad de: ';
        for (
          let i = 0;
          i < this.dataMultiple[this.namePath].multiple_servicios.length;
          i++
        ) {
          if (
            this.dataMultiple[this.namePath].multiple_servicios[i].check ===
              1 &&
            (this.dataMultiple[this.namePath].multiple_servicios[i].name ===
              'Eps' ||
              this.dataMultiple[this.namePath].multiple_servicios[i].name ===
                'Afp' ||
              this.dataMultiple[this.namePath].multiple_servicios[i].name ===
                'Ccf') &&
            this.predeterminados[this.namePath].multiple_servicios[
              i
            ].id_list.toString() ===
              this.dataMultiple[this.namePath].multiple_servicios[
                i
              ].id_list.toString()
          ) {
            ninguno =
              ninguno +
              ' *' +
              this.dataMultiple[this.namePath].multiple_servicios[i].name +
              ' ';
          }
          if (
            this.dataMultiple[this.namePath].multiple_servicios[i].name ==
            'Administración'
          ) {
            switch (
              this.dataForm[this.namePath].info_afiliacion.id_list_novedad
            ) {
              case 1:
                if (
                  this.dataMultiple[this.namePath].multiple_servicios[i]
                    .valoringreso > 59000
                ) {
                  errorsAportes.push({
                    name: 'La Administración es mayor a $ 60.000, revisa si los servicios están bien',
                    value: false,
                  });
                }
                break;
              case 2:
              case 4:
                if (
                  this.dataMultiple[this.namePath].multiple_servicios[i].valor >
                  59000
                ) {
                  errorsAportes.push({
                    name: 'La Administración es mayor a $ 60.000, revisa si los servicios están bien',
                    value: false,
                  });
                }
                break;
              case 3:
                if (
                  this.dataMultiple[this.namePath].multiple_servicios[i]
                    .valorretiro > 59000
                ) {
                  errorsAportes.push({
                    name: 'La Administración es mayor a $ 60.000, revisa si los servicios están bien',
                    value: false,
                  });
                }
                break;
            }
          }
        }
        if (ninguno !== 'Debe asignar la entidad de: ') {
          errorsAportes.push({ name: ninguno, value: true });
        }

        let fechaHoy = this.fecha().fecha.minHoy;
        let mesActual = parseInt(moment(fechaHoy).format('MM'));
        let anoActual = parseInt(moment(fechaHoy).format('YYYY'));

        if (
          mesActual != this.mesPeriodo.id ||
          anoActual != this.anoPeriodo.id
        ) {
          errorsAportes.push({
            name: 'El periodo de aporte es diferente al mes actual',
            value: false,
          });
        }
        return errorsAportes;
      } catch (e) {
        console.log(e);
      }
    },
    pendientesAfiliado(data) {
      let name = '';
      for (let i = 0; i < data.length; i++) {
        name += data[i].name + ', ';
      }
      return name;
    },
  },
};
